import React from "react";

const Contact = () => {
  return (
    <div>
      <h1 className="route">Contact</h1>
    </div>
  );
};

export default Contact;
